<template>
  <slot>
    <div :class="wrapperClasses" :id="identifier" v-show="!state.hidden">
      <fieldset class="govuk-fieldset" :aria-describedby="hintId" role="group">
        <label class="govuk-label" v-show="!state.hiddenLabel" v-html="displayName"> </label>
        <span :id="titleId" class="govuk-title">{{ displayTitle }}</span>

        <div :class="displayHintClasses" v-if="displayHint" v-on:click="toggleHintSection" v-html="displayHintText"></div>
        <div :id="hintId" class="govuk-hint" v-show="!state.hiddenHint" v-html="displayHint"></div>

        <span :id="errorId" class="govuk-error-message" v-show="!state.isValid">
          <ul v-if="currentErrors.length > 0">
            <li v-for="(errorMessage, errIndex) in currentErrors" v-bind:key="errIndex">
              {{ errorMessage.message }}
            </li>
          </ul>
        </span>
        <div class="govuk-date-input" :id="controlId">
          <div class="govuk-date-input__item">
            <div class="govuk-form-group">
              <label class="govuk-label govuk-date-input__label" :for="controlId + '-day'">{{ t("day", "_utility") }}</label>
              <input
                class="govuk-input govuk-date-input__input govuk-input--width-2"
                title="Uveďte dátum narodenia. "
                :id="controlId + '-day'"
                maxlength="2"
                :name="controlId + '-day'"
                v-model="inputValues.day"
              />
            </div>
          </div>
          <div class="govuk-date-input__item">
            <div class="govuk-form-group">
              <label class="govuk-label govuk-date-input__label" :for="controlId + '-month'">{{ t("month", "_utility") }}</label>
              <input
                class="govuk-input govuk-date-input__input govuk-input--width-2"
                title="Uveďte dátum narodenia. "
                :id="controlId + '-month'"
                maxlength="2"
                :name="controlId + '-month'"
                v-model="inputValues.month"
              />
            </div>
          </div>
          <div class="govuk-date-input__item">
            <div class="govuk-form-group">
              <label class="govuk-label govuk-date-input__label" :for="controlId + '-year'">{{ t("year", "_utility") }}</label>
              <input
                class="govuk-input govuk-date-input__input govuk-input--width-4"
                title="Uveďte dátum narodenia. "
                :id="controlId + '-year'"
                v-on:blur="focusOut()"
                maxlength="4"
                :name="controlId + '-year'"
                v-model="inputValues.year"
              />
            </div>
          </div>
        </div>
      </fieldset>
    </div>
  </slot>
</template>
<script lang="ts" src="@/library/templates/default/controls/Date.ts"></script>
